export const COOKIE_OPTIONS: ICookieOptions = {
  secure: true,
  domain: '.airbaltic.com',
  sameSite: 'lax'
}

export const CAMPAIGN_COUNTER_COOKIE_NAME = 'campaignCounter'
export const RECENT_SEARCH_COOKIE_NAME = 'recentSearch'

export const SELF_SERVICE_NEW_PAGE_VARIANT = 'A'
export const SELF_SERVICE_OLD_PAGE_VARIANT = 'B'

export type SELF_SERVICE_VARIANTS = typeof SELF_SERVICE_NEW_PAGE_VARIANT | typeof SELF_SERVICE_OLD_PAGE_VARIANT
